import { Modal, ModalBody } from "react-bootstrap";

import { deleteAnnouncement } from "../../api/announcement";
import AnnouncementDelete from "../../components/Announcement/AnnouncementDelete";
import { deleteAnnouncementItem } from "../../types/announcement";

interface Props {
  deleteItem: deleteAnnouncementItem;
  onClose: () => void;
  fetchAnnouncements: () => void;
}

const AnnouncementDeleteContainer = ({ deleteItem, onClose, fetchAnnouncements }: Props) => {
  const handleDelete = async () => {
    try {
      await deleteAnnouncement(deleteItem.id);
      fetchAnnouncements();
      onClose();
    } catch (e: any) {
      alert(e.response.data.message);
    }
  };

  return (
    <Modal show onHide={onClose} centered size="sm">
      <ModalBody className="text-center m-3" style={{ margin: 0, padding: 0 }}>
        <AnnouncementDelete title={deleteItem.title} onClose={onClose} handleDelete={handleDelete} />
      </ModalBody>
    </Modal>
  );
};

export default AnnouncementDeleteContainer;
